import {FileColumn} from '../manager/tree-manager/file-column';

export class CollapseEvent {
  public collapse: boolean;
  public column: FileColumn;

  constructor(collapse: boolean, column: FileColumn) {
    this.collapse = collapse;
    this.column = column;
  }
}
